var items = {
  "block.minecraft.air": "air",
  "block.minecraft.stone": "stone",
  "block.minecraft.granite": "granite",
  "block.minecraft.polished_granite": "polished granite",
  "block.minecraft.diorite": "diorite",
  "block.minecraft.polished_diorite": "polished diorite",
  "block.minecraft.andesite": "andesite",
  "block.minecraft.polished_andesite": "polished andesite",
  "block.minecraft.grass_block": "grass block",
  "block.minecraft.dirt": "dirt",
  "block.minecraft.coarse_dirt": "coarse dirt",
  "block.minecraft.podzol": "podzol",
  "block.minecraft.crimson_nylium": "crimson nylium",
  "block.minecraft.warped_nylium": "warped nylium",
  "block.minecraft.cobblestone": "cobblestone",
  "block.minecraft.oak_planks": "oak planks",
  "block.minecraft.spruce_planks": "spruce planks",
  "block.minecraft.birch_planks": "birch planks",
  "block.minecraft.jungle_planks": "jungle planks",
  "block.minecraft.acacia_planks": "acacia planks",
  "block.minecraft.dark_oak_planks": "dark oak planks",
  "block.minecraft.crimson_planks": "crimson planks",
  "block.minecraft.warped_planks": "warped planks",
  "block.minecraft.oak_sapling": "oak sapling",
  "block.minecraft.spruce_sapling": "spruce sapling",
  "block.minecraft.birch_sapling": "birch sapling",
  "block.minecraft.jungle_sapling": "jungle sapling",
  "block.minecraft.acacia_sapling": "acacia sapling",
  "block.minecraft.dark_oak_sapling": "dark oak sapling",
  "block.minecraft.bedrock": "bedrock",
  "block.minecraft.sand": "sand",
  "block.minecraft.red_sand": "red sand",
  "block.minecraft.gravel": "gravel",
  "block.minecraft.gold_ore": "gold ore",
  "block.minecraft.iron_ore": "iron ore",
  "block.minecraft.coal_ore": "coal ore",
  "block.minecraft.nether_gold_ore": "nether gold ore",
  "block.minecraft.oak_log": "oak log",
  "block.minecraft.spruce_log": "spruce log",
  "block.minecraft.birch_log": "birch log",
  "block.minecraft.jungle_log": "jungle log",
  "block.minecraft.acacia_log": "acacia log",
  "block.minecraft.dark_oak_log": "dark oak log",
  "block.minecraft.crimson_stem": "crimson stem",
  "block.minecraft.warped_stem": "warped stem",
  "block.minecraft.stripped_oak_log": "stripped oak log",
  "block.minecraft.stripped_spruce_log": "stripped spruce log",
  "block.minecraft.stripped_birch_log": "stripped birch log",
  "block.minecraft.stripped_jungle_log": "stripped jungle log",
  "block.minecraft.stripped_acacia_log": "stripped acacia log",
  "block.minecraft.stripped_dark_oak_log": "stripped dark oak log",
  "block.minecraft.stripped_crimson_stem": "stripped crimson stem",
  "block.minecraft.stripped_warped_stem": "stripped warped stem",
  "block.minecraft.stripped_oak_wood": "stripped oak wood",
  "block.minecraft.stripped_spruce_wood": "stripped spruce wood",
  "block.minecraft.stripped_birch_wood": "stripped birch wood",
  "block.minecraft.stripped_jungle_wood": "stripped jungle wood",
  "block.minecraft.stripped_acacia_wood": "stripped acacia wood",
  "block.minecraft.stripped_dark_oak_wood": "stripped dark oak wood",
  "block.minecraft.stripped_crimson_hyphae": "stripped crimson hyphae",
  "block.minecraft.stripped_warped_hyphae": "stripped warped hyphae",
  "block.minecraft.oak_wood": "oak wood",
  "block.minecraft.spruce_wood": "spruce wood",
  "block.minecraft.birch_wood": "birch wood",
  "block.minecraft.jungle_wood": "jungle wood",
  "block.minecraft.acacia_wood": "acacia wood",
  "block.minecraft.dark_oak_wood": "dark oak wood",
  "block.minecraft.crimson_hyphae": "crimson hyphae",
  "block.minecraft.warped_hyphae": "warped hyphae",
  "block.minecraft.oak_leaves": "oak leaves",
  "block.minecraft.spruce_leaves": "spruce leaves",
  "block.minecraft.birch_leaves": "birch leaves",
  "block.minecraft.jungle_leaves": "jungle leaves",
  "block.minecraft.acacia_leaves": "acacia leaves",
  "block.minecraft.dark_oak_leaves": "dark oak leaves",
  "block.minecraft.sponge": "sponge",
  "block.minecraft.wet_sponge": "wet sponge",
  "block.minecraft.glass": "glass",
  "block.minecraft.lapis_ore": "lapis lazuli ore",
  "block.minecraft.lapis_block": "lapis lazuli block",
  "block.minecraft.dispenser": "dispenser",
  "block.minecraft.sandstone": "sandstone",
  "block.minecraft.chiseled_sandstone": "chiselled sandstone",
  "block.minecraft.cut_sandstone": "cut sandstone",
  "block.minecraft.note_block": "note block",
  "block.minecraft.powered_rail": "powered rail",
  "block.minecraft.detector_rail": "detector rail",
  "block.minecraft.sticky_piston": "sticky piston",
  "block.minecraft.cobweb": "cobweb",
  "block.minecraft.grass": "grass",
  "block.minecraft.fern": "fern",
  "block.minecraft.dead_bush": "dead bush",
  "block.minecraft.seagrass": "seagrass",
  "block.minecraft.sea_pickle": "sea pickle",
  "block.minecraft.piston": "piston",
  "block.minecraft.white_wool": "white wool",
  "block.minecraft.orange_wool": "orange wool",
  "block.minecraft.magenta_wool": "magenta wool",
  "block.minecraft.light_blue_wool": "light blue wool",
  "block.minecraft.yellow_wool": "yellow wool",
  "block.minecraft.lime_wool": "lime wool",
  "block.minecraft.pink_wool": "pink wool",
  "block.minecraft.gray_wool": "grey wool",
  "block.minecraft.light_gray_wool": "light grey wool",
  "block.minecraft.cyan_wool": "cyan wool",
  "block.minecraft.purple_wool": "purple wool",
  "block.minecraft.blue_wool": "blue wool",
  "block.minecraft.brown_wool": "brown wool",
  "block.minecraft.green_wool": "green wool",
  "block.minecraft.red_wool": "red wool",
  "block.minecraft.black_wool": "black wool",
  "block.minecraft.dandelion": "dandelion",
  "block.minecraft.poppy": "poppy",
  "block.minecraft.blue_orchid": "blue orchid",
  "block.minecraft.allium": "allium",
  "block.minecraft.azure_bluet": "azure bluet",
  "block.minecraft.red_tulip": "red tulip",
  "block.minecraft.orange_tulip": "orange tulip",
  "block.minecraft.white_tulip": "white tulip",
  "block.minecraft.pink_tulip": "pink tulip",
  "block.minecraft.oxeye_daisy": "oxeye daisy",
  "block.minecraft.cornflower": "cornflower",
  "block.minecraft.lily_of_the_valley": "lily of the valley",
  "block.minecraft.wither_rose": "wither rose",
  "block.minecraft.brown_mushroom": "brown mushroom",
  "block.minecraft.red_mushroom": "red mushroom",
  "block.minecraft.crimson_fungus": "crimson fungus",
  "block.minecraft.warped_fungus": "warped fungus",
  "block.minecraft.crimson_roots": "crimson roots",
  "block.minecraft.warped_roots": "warped roots",
  "block.minecraft.nether_sprouts": "nether sprouts",
  "block.minecraft.weeping_vines": "weeping vines",
  "block.minecraft.twisting_vines": "twisting vines",
  "block.minecraft.sugar_cane": "sugar cane",
  "block.minecraft.kelp": "kelp",
  "block.minecraft.bamboo": "bamboo",
  "block.minecraft.gold_block": "block of gold",
  "block.minecraft.iron_block": "block of iron",
  "block.minecraft.oak_slab": "oak slab",
  "block.minecraft.spruce_slab": "spruce slab",
  "block.minecraft.birch_slab": "birch slab",
  "block.minecraft.jungle_slab": "jungle slab",
  "block.minecraft.acacia_slab": "acacia slab",
  "block.minecraft.dark_oak_slab": "dark oak slab",
  "block.minecraft.crimson_slab": "crimson slab",
  "block.minecraft.warped_slab": "warped slab",
  "block.minecraft.stone_slab": "stone slab",
  "block.minecraft.smooth_stone_slab": "smooth stone slab",
  "block.minecraft.sandstone_slab": "sandstone slab",
  "block.minecraft.cut_sandstone_slab": "cut sandstone slab",
  "block.minecraft.petrified_oak_slab": "petrified oak slab",
  "block.minecraft.cobblestone_slab": "cobblestone slab",
  "block.minecraft.brick_slab": "brick slab",
  "block.minecraft.stone_brick_slab": "stone brick slab",
  "block.minecraft.nether_brick_slab": "nether brick slab",
  "block.minecraft.quartz_slab": "quartz slab",
  "block.minecraft.red_sandstone_slab": "red sandstone slab",
  "block.minecraft.cut_red_sandstone_slab": "cut red sandstone slab",
  "block.minecraft.purpur_slab": "purpur slab",
  "block.minecraft.prismarine_slab": "prismarine slab",
  "block.minecraft.prismarine_brick_slab": "prismarine brick slab",
  "block.minecraft.dark_prismarine_slab": "dark prismarine slab",
  "block.minecraft.smooth_quartz": "smooth quartz block",
  "block.minecraft.smooth_red_sandstone": "smooth red sandstone",
  "block.minecraft.smooth_sandstone": "smooth sandstone",
  "block.minecraft.smooth_stone": "smooth stone",
  "block.minecraft.bricks": "bricks",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "bookshelf",
  "block.minecraft.mossy_cobblestone": "mossy cobblestone",
  "block.minecraft.obsidian": "obsidian",
  "block.minecraft.torch": "torch",
  "block.minecraft.end_rod": "end rod",
  "block.minecraft.chorus_plant": "chorus plant",
  "block.minecraft.chorus_flower": "chorus flower",
  "block.minecraft.purpur_block": "purpur block",
  "block.minecraft.purpur_pillar": "purpur pillar",
  "block.minecraft.purpur_stairs": "purpur stairs",
  "block.minecraft.spawner": "spawner",
  "block.minecraft.oak_stairs": "oak stairs",
  "block.minecraft.chest": "chest",
  "block.minecraft.diamond_ore": "diamond ore",
  "block.minecraft.diamond_block": "block of diamond",
  "block.minecraft.crafting_table": "crafting table",
  "block.minecraft.farmland": "farmland",
  "block.minecraft.furnace": "furnace",
  "block.minecraft.ladder": "ladder",
  "block.minecraft.rail": "rail",
  "block.minecraft.cobblestone_stairs": "cobblestone stairs",
  "block.minecraft.lever": "lever",
  "block.minecraft.stone_pressure_plate": "stone pressure plate",
  "block.minecraft.oak_pressure_plate": "oak pressure plate",
  "block.minecraft.spruce_pressure_plate": "spruce pressure plate",
  "block.minecraft.birch_pressure_plate": "birch pressure plate",
  "block.minecraft.jungle_pressure_plate": "jungle pressure plate",
  "block.minecraft.acacia_pressure_plate": "acacia pressure plate",
  "block.minecraft.dark_oak_pressure_plate": "dark oak pressure plate",
  "block.minecraft.crimson_pressure_plate": "crimson pressure plate",
  "block.minecraft.warped_pressure_plate": "warped pressure plate",
  "block.minecraft.polished_blackstone_pressure_plate": "polished blackstone pressure plate",
  "block.minecraft.redstone_ore": "redstone ore",
  "block.minecraft.redstone_torch": "redstone torch",
  "block.minecraft.snow": "snow",
  "block.minecraft.ice": "ice",
  "block.minecraft.snow_block": "snow block",
  "block.minecraft.cactus": "cactus",
  "block.minecraft.clay": "clay",
  "block.minecraft.jukebox": "jukebox",
  "block.minecraft.oak_fence": "oak fence",
  "block.minecraft.spruce_fence": "spruce fence",
  "block.minecraft.birch_fence": "birch fence",
  "block.minecraft.jungle_fence": "jungle fence",
  "block.minecraft.acacia_fence": "acacia fence",
  "block.minecraft.dark_oak_fence": "dark oak fence",
  "block.minecraft.crimson_fence": "crimson fence",
  "block.minecraft.warped_fence": "warped fence",
  "block.minecraft.pumpkin": "pumpkin",
  "block.minecraft.carved_pumpkin": "carved pumpkin",
  "block.minecraft.netherrack": "netherrack",
  "block.minecraft.soul_sand": "soul sand",
  "block.minecraft.soul_soil": "soul soil",
  "block.minecraft.basalt": "basalt",
  "block.minecraft.polished_basalt": "polished basalt",
  "block.minecraft.soul_torch": "soul torch",
  "block.minecraft.glowstone": "glowstone",
  "block.minecraft.jack_o_lantern": "jack o'lantern",
  "block.minecraft.oak_trapdoor": "oak trapdoor",
  "block.minecraft.spruce_trapdoor": "spruce trapdoor",
  "block.minecraft.birch_trapdoor": "birch trapdoor",
  "block.minecraft.jungle_trapdoor": "jungle trapdoor",
  "block.minecraft.acacia_trapdoor": "acacia trapdoor",
  "block.minecraft.dark_oak_trapdoor": "dark oak trapdoor",
  "block.minecraft.crimson_trapdoor": "crimson trapdoor",
  "block.minecraft.warped_trapdoor": "warped trapdoor",
  "block.minecraft.infested_stone": "infested stone",
  "block.minecraft.infested_cobblestone": "infested cobblestone",
  "block.minecraft.infested_stone_bricks": "infested stone bricks",
  "block.minecraft.infested_mossy_stone_bricks": "infested mossy stone bricks",
  "block.minecraft.infested_cracked_stone_bricks": "infested cracked stone bricks",
  "block.minecraft.infested_chiseled_stone_bricks": "infested chiselled stone bricks",
  "block.minecraft.stone_bricks": "stone bricks",
  "block.minecraft.mossy_stone_bricks": "mossy stone bricks",
  "block.minecraft.cracked_stone_bricks": "cracked stone bricks",
  "block.minecraft.chiseled_stone_bricks": "chiselled stone bricks",
  "block.minecraft.brown_mushroom_block": "brown mushroom block",
  "block.minecraft.red_mushroom_block": "red mushroom block",
  "block.minecraft.mushroom_stem": "mushroom stem",
  "block.minecraft.iron_bars": "iron bars",
  "block.minecraft.chain": "chain",
  "block.minecraft.glass_pane": "glass pane",
  "block.minecraft.melon": "watermelon",
  "block.minecraft.vine": "vines",
  "block.minecraft.oak_fence_gate": "oak fence gate",
  "block.minecraft.spruce_fence_gate": "spruce fence gate",
  "block.minecraft.birch_fence_gate": "birch fence gate",
  "block.minecraft.jungle_fence_gate": "jungle fence gate",
  "block.minecraft.acacia_fence_gate": "acacia fence gate",
  "block.minecraft.dark_oak_fence_gate": "dark oak fence gate",
  "block.minecraft.crimson_fence_gate": "crimson fence gate",
  "block.minecraft.warped_fence_gate": "warped fence gate",
  "block.minecraft.brick_stairs": "brick stairs",
  "block.minecraft.stone_brick_stairs": "stone brick stairs",
  "block.minecraft.mycelium": "mycelium",
  "block.minecraft.lily_pad": "lily pad",
  "block.minecraft.nether_bricks": "nether bricks",
  "block.minecraft.cracked_nether_bricks": "cracked nether bricks",
  "block.minecraft.chiseled_nether_bricks": "chiselled nether bricks",
  "block.minecraft.nether_brick_fence": "nether brick fence",
  "block.minecraft.nether_brick_stairs": "nether brick stairs",
  "block.minecraft.enchanting_table": "enchanting table",
  "block.minecraft.end_portal_frame": "end portal frame",
  "block.minecraft.end_stone": "end stone",
  "block.minecraft.end_stone_bricks": "end stone bricks",
  "block.minecraft.dragon_egg": "dragon egg",
  "block.minecraft.redstone_lamp": "redstone lamp",
  "block.minecraft.sandstone_stairs": "sandstone stairs",
  "block.minecraft.emerald_ore": "emerald ore",
  "block.minecraft.ender_chest": "ender chest",
  "block.minecraft.tripwire_hook": "tripwire hook",
  "block.minecraft.emerald_block": "block of emerald",
  "block.minecraft.spruce_stairs": "spruce stairs",
  "block.minecraft.birch_stairs": "birch stairs",
  "block.minecraft.jungle_stairs": "jungle stairs",
  "block.minecraft.crimson_stairs": "crimson stairs",
  "block.minecraft.warped_stairs": "warped stairs",
  "block.minecraft.command_block": "command block",
  "block.minecraft.beacon": "beacon",
  "block.minecraft.cobblestone_wall": "cobblestone wall",
  "block.minecraft.mossy_cobblestone_wall": "mossy cobblestone wall",
  "block.minecraft.brick_wall": "brick wall",
  "block.minecraft.prismarine_wall": "prismarine wall",
  "block.minecraft.red_sandstone_wall": "red sandstone wall",
  "block.minecraft.mossy_stone_brick_wall": "mossy stone brick wall",
  "block.minecraft.granite_wall": "granite wall",
  "block.minecraft.stone_brick_wall": "stone brick wall",
  "block.minecraft.nether_brick_wall": "nether brick wall",
  "block.minecraft.andesite_wall": "andesite wall",
  "block.minecraft.red_nether_brick_wall": "red nether brick wall",
  "block.minecraft.sandstone_wall": "sandstone wall",
  "block.minecraft.end_stone_brick_wall": "end stone brick wall",
  "block.minecraft.diorite_wall": "diorite wall",
  "block.minecraft.blackstone_wall": "blackstone wall",
  "block.minecraft.polished_blackstone_wall": "polished blackstone wall",
  "block.minecraft.polished_blackstone_brick_wall": "polished blackstone brick wall",
  "block.minecraft.stone_button": "stone button",
  "block.minecraft.oak_button": "oak button",
  "block.minecraft.spruce_button": "spruce button",
  "block.minecraft.birch_button": "birch button",
  "block.minecraft.jungle_button": "jungle button",
  "block.minecraft.acacia_button": "acacia button",
  "block.minecraft.dark_oak_button": "dark oak button",
  "block.minecraft.crimson_button": "crimson button",
  "block.minecraft.warped_button": "warped button",
  "block.minecraft.polished_blackstone_button": "polished blackstone button",
  "block.minecraft.anvil": "anvil",
  "block.minecraft.chipped_anvil": "chipped anvil",
  "block.minecraft.damaged_anvil": "damaged anvil",
  "block.minecraft.trapped_chest": "trapped chest",
  "block.minecraft.light_weighted_pressure_plate": "light weighted pressure plate",
  "block.minecraft.heavy_weighted_pressure_plate": "heavy weighted pressure plate",
  "block.minecraft.daylight_detector": "daylight detector",
  "block.minecraft.redstone_block": "block of redstone",
  "block.minecraft.nether_quartz_ore": "nether quartz ore",
  "block.minecraft.hopper": "hopper",
  "block.minecraft.chiseled_quartz_block": "chiselled quartz block",
  "block.minecraft.quartz_block": "block of quartz",
  "block.minecraft.quartz_bricks": "quartz bricks",
  "block.minecraft.quartz_pillar": "quartz pillar",
  "block.minecraft.quartz_stairs": "quartz stairs",
  "block.minecraft.activator_rail": "activator rail",
  "block.minecraft.dropper": "dropper",
  "block.minecraft.white_terracotta": "white terracotta",
  "block.minecraft.orange_terracotta": "orange terracotta",
  "block.minecraft.magenta_terracotta": "magenta terracotta",
  "block.minecraft.light_blue_terracotta": "light blue terracotta",
  "block.minecraft.yellow_terracotta": "yellow terracotta",
  "block.minecraft.lime_terracotta": "lime terracotta",
  "block.minecraft.pink_terracotta": "pink terracotta",
  "block.minecraft.gray_terracotta": "grey terracotta",
  "block.minecraft.light_gray_terracotta": "light grey terracotta",
  "block.minecraft.cyan_terracotta": "cyan terracotta",
  "block.minecraft.purple_terracotta": "purple terracotta",
  "block.minecraft.blue_terracotta": "blue terracotta",
  "block.minecraft.brown_terracotta": "brown terracotta",
  "block.minecraft.green_terracotta": "green terracotta",
  "block.minecraft.red_terracotta": "red terracotta",
  "block.minecraft.black_terracotta": "black terracotta",
  "block.minecraft.barrier": "barrier",
  "block.minecraft.iron_trapdoor": "iron trapdoor",
  "block.minecraft.hay_block": "hay bale",
  "block.minecraft.white_carpet": "white carpet",
  "block.minecraft.orange_carpet": "orange carpet",
  "block.minecraft.magenta_carpet": "magenta carpet",
  "block.minecraft.light_blue_carpet": "light blue carpet",
  "block.minecraft.yellow_carpet": "yellow carpet",
  "block.minecraft.lime_carpet": "lime carpet",
  "block.minecraft.pink_carpet": "pink carpet",
  "block.minecraft.gray_carpet": "grey carpet",
  "block.minecraft.light_gray_carpet": "light grey carpet",
  "block.minecraft.cyan_carpet": "cyan carpet",
  "block.minecraft.purple_carpet": "purple carpet",
  "block.minecraft.blue_carpet": "blue carpet",
  "block.minecraft.brown_carpet": "brown carpet",
  "block.minecraft.green_carpet": "green carpet",
  "block.minecraft.red_carpet": "red carpet",
  "block.minecraft.black_carpet": "black carpet",
  "block.minecraft.terracotta": "terracotta",
  "block.minecraft.coal_block": "block of coal",
  "block.minecraft.packed_ice": "packed ice",
  "block.minecraft.acacia_stairs": "acacia stairs",
  "block.minecraft.dark_oak_stairs": "dark oak stairs",
  "block.minecraft.slime_block": "slime block",
  "block.minecraft.grass_path": "grass path",
  "block.minecraft.sunflower": "sunflower",
  "block.minecraft.lilac": "lilac",
  "block.minecraft.rose_bush": "rose bush",
  "block.minecraft.peony": "peony",
  "block.minecraft.tall_grass": "tall grass",
  "block.minecraft.large_fern": "large fern",
  "block.minecraft.white_stained_glass": "white stained glass",
  "block.minecraft.orange_stained_glass": "orange stained glass",
  "block.minecraft.magenta_stained_glass": "magenta stained glass",
  "block.minecraft.light_blue_stained_glass": "light blue stained glass",
  "block.minecraft.yellow_stained_glass": "yellow stained glass",
  "block.minecraft.lime_stained_glass": "lime stained glass",
  "block.minecraft.pink_stained_glass": "pink stained glass",
  "block.minecraft.gray_stained_glass": "grey stained glass",
  "block.minecraft.light_gray_stained_glass": "light grey stained glass",
  "block.minecraft.cyan_stained_glass": "cyan stained glass",
  "block.minecraft.purple_stained_glass": "purple stained glass",
  "block.minecraft.blue_stained_glass": "blue stained glass",
  "block.minecraft.brown_stained_glass": "brown stained glass",
  "block.minecraft.green_stained_glass": "green stained glass",
  "block.minecraft.red_stained_glass": "red stained glass",
  "block.minecraft.black_stained_glass": "black stained glass",
  "block.minecraft.white_stained_glass_pane": "white stained glass pane",
  "block.minecraft.orange_stained_glass_pane": "orange stained glass pane",
  "block.minecraft.magenta_stained_glass_pane": "magenta stained glass pane",
  "block.minecraft.light_blue_stained_glass_pane": "light blue stained glass pane",
  "block.minecraft.yellow_stained_glass_pane": "yellow stained glass pane",
  "block.minecraft.lime_stained_glass_pane": "lime stained glass pane",
  "block.minecraft.pink_stained_glass_pane": "pink stained glass pane",
  "block.minecraft.gray_stained_glass_pane": "grey stained glass pane",
  "block.minecraft.light_gray_stained_glass_pane": "light grey stained glass pane",
  "block.minecraft.cyan_stained_glass_pane": "cyan stained glass pane",
  "block.minecraft.purple_stained_glass_pane": "purple stained glass pane",
  "block.minecraft.blue_stained_glass_pane": "blue stained glass pane",
  "block.minecraft.brown_stained_glass_pane": "brown stained glass pane",
  "block.minecraft.green_stained_glass_pane": "green stained glass pane",
  "block.minecraft.red_stained_glass_pane": "red stained glass pane",
  "block.minecraft.black_stained_glass_pane": "black stained glass pane",
  "block.minecraft.prismarine": "prismarine",
  "block.minecraft.prismarine_bricks": "prismarine bricks",
  "block.minecraft.dark_prismarine": "dark prismarine",
  "block.minecraft.prismarine_stairs": "prismarine stairs",
  "block.minecraft.prismarine_brick_stairs": "prismarine brick stairs",
  "block.minecraft.dark_prismarine_stairs": "dark prismarine stairs",
  "block.minecraft.sea_lantern": "sea lantern",
  "block.minecraft.red_sandstone": "red sandstone",
  "block.minecraft.chiseled_red_sandstone": "chiselled red sandstone",
  "block.minecraft.cut_red_sandstone": "cut red sandstone",
  "block.minecraft.red_sandstone_stairs": "red sandstone stairs",
  "block.minecraft.repeating_command_block": "repeating command block",
  "block.minecraft.chain_command_block": "chain command block",
  "block.minecraft.magma_block": "magma block",
  "block.minecraft.nether_wart_block": "nether wart block",
  "block.minecraft.warped_wart_block": "warped wart block",
  "block.minecraft.red_nether_bricks": "red nether bricks",
  "block.minecraft.bone_block": "bone block",
  "block.minecraft.structure_void": "structure void",
  "block.minecraft.observer": "observer",
  "block.minecraft.shulker_box": "shulker box",
  "block.minecraft.white_shulker_box": "white shulker box",
  "block.minecraft.orange_shulker_box": "orange shulker box",
  "block.minecraft.magenta_shulker_box": "magenta shulker box",
  "block.minecraft.light_blue_shulker_box": "light blue shulker box",
  "block.minecraft.yellow_shulker_box": "yellow shulker box",
  "block.minecraft.lime_shulker_box": "lime shulker box",
  "block.minecraft.pink_shulker_box": "pink shulker box",
  "block.minecraft.gray_shulker_box": "grey shulker box",
  "block.minecraft.light_gray_shulker_box": "light grey shulker box",
  "block.minecraft.cyan_shulker_box": "cyan shulker box",
  "block.minecraft.purple_shulker_box": "purple shulker box",
  "block.minecraft.blue_shulker_box": "blue shulker box",
  "block.minecraft.brown_shulker_box": "brown shulker box",
  "block.minecraft.green_shulker_box": "green shulker box",
  "block.minecraft.red_shulker_box": "red shulker box",
  "block.minecraft.black_shulker_box": "black shulker box",
  "block.minecraft.white_glazed_terracotta": "white glazed terracotta",
  "block.minecraft.orange_glazed_terracotta": "orange glazed terracotta",
  "block.minecraft.magenta_glazed_terracotta": "magenta glazed terracotta",
  "block.minecraft.light_blue_glazed_terracotta": "light blue glazed terracotta",
  "block.minecraft.yellow_glazed_terracotta": "yellow glazed terracotta",
  "block.minecraft.lime_glazed_terracotta": "lime glazed terracotta",
  "block.minecraft.pink_glazed_terracotta": "pink glazed terracotta",
  "block.minecraft.gray_glazed_terracotta": "grey glazed terracotta",
  "block.minecraft.light_gray_glazed_terracotta": "light grey glazed terracotta",
  "block.minecraft.cyan_glazed_terracotta": "cyan glazed terracotta",
  "block.minecraft.purple_glazed_terracotta": "purple glazed terracotta",
  "block.minecraft.blue_glazed_terracotta": "blue glazed terracotta",
  "block.minecraft.brown_glazed_terracotta": "brown glazed terracotta",
  "block.minecraft.green_glazed_terracotta": "green glazed terracotta",
  "block.minecraft.red_glazed_terracotta": "red glazed terracotta",
  "block.minecraft.black_glazed_terracotta": "black glazed terracotta",
  "block.minecraft.white_concrete": "white concrete",
  "block.minecraft.orange_concrete": "orange concrete",
  "block.minecraft.magenta_concrete": "magenta concrete",
  "block.minecraft.light_blue_concrete": "light blue concrete",
  "block.minecraft.yellow_concrete": "yellow concrete",
  "block.minecraft.lime_concrete": "lime concrete",
  "block.minecraft.pink_concrete": "pink concrete",
  "block.minecraft.gray_concrete": "grey concrete",
  "block.minecraft.light_gray_concrete": "light grey concrete",
  "block.minecraft.cyan_concrete": "cyan concrete",
  "block.minecraft.purple_concrete": "purple concrete",
  "block.minecraft.blue_concrete": "blue concrete",
  "block.minecraft.brown_concrete": "brown concrete",
  "block.minecraft.green_concrete": "green concrete",
  "block.minecraft.red_concrete": "red concrete",
  "block.minecraft.black_concrete": "black concrete",
  "block.minecraft.white_concrete_powder": "white concrete powder",
  "block.minecraft.orange_concrete_powder": "orange concrete powder",
  "block.minecraft.magenta_concrete_powder": "magenta concrete powder",
  "block.minecraft.light_blue_concrete_powder": "light blue concrete powder",
  "block.minecraft.yellow_concrete_powder": "yellow concrete powder",
  "block.minecraft.lime_concrete_powder": "lime concrete powder",
  "block.minecraft.pink_concrete_powder": "pink concrete powder",
  "block.minecraft.gray_concrete_powder": "grey concrete powder",
  "block.minecraft.light_gray_concrete_powder": "light grey concrete powder",
  "block.minecraft.cyan_concrete_powder": "cyan concrete powder",
  "block.minecraft.purple_concrete_powder": "purple concrete powder",
  "block.minecraft.blue_concrete_powder": "blue concrete powder",
  "block.minecraft.brown_concrete_powder": "brown concrete powder",
  "block.minecraft.green_concrete_powder": "green concrete powder",
  "block.minecraft.red_concrete_powder": "red concrete powder",
  "block.minecraft.black_concrete_powder": "black concrete powder",
  "block.minecraft.turtle_egg": "turtle egg",
  "block.minecraft.dead_tube_coral_block": "dead tube coral block",
  "block.minecraft.dead_brain_coral_block": "dead brain coral block",
  "block.minecraft.dead_bubble_coral_block": "dead bubble coral block",
  "block.minecraft.dead_fire_coral_block": "dead fire coral block",
  "block.minecraft.dead_horn_coral_block": "dead horn coral block",
  "block.minecraft.tube_coral_block": "tube coral block",
  "block.minecraft.brain_coral_block": "brain coral block",
  "block.minecraft.bubble_coral_block": "bubble coral block",
  "block.minecraft.fire_coral_block": "fire coral block",
  "block.minecraft.horn_coral_block": "horn coral block",
  "block.minecraft.tube_coral": "tube coral",
  "block.minecraft.brain_coral": "brain coral",
  "block.minecraft.bubble_coral": "bubble coral",
  "block.minecraft.fire_coral": "fire coral",
  "block.minecraft.horn_coral": "horn coral",
  "block.minecraft.dead_brain_coral": "dead brain coral",
  "block.minecraft.dead_bubble_coral": "dead bubble coral",
  "block.minecraft.dead_fire_coral": "dead fire coral",
  "block.minecraft.dead_horn_coral": "dead horn coral",
  "block.minecraft.dead_tube_coral": "dead tube coral",
  "block.minecraft.tube_coral_fan": "tube coral fan",
  "block.minecraft.brain_coral_fan": "brain coral fan",
  "block.minecraft.bubble_coral_fan": "bubble coral fan",
  "block.minecraft.fire_coral_fan": "fire coral fan",
  "block.minecraft.horn_coral_fan": "horn coral fan",
  "block.minecraft.dead_tube_coral_fan": "dead tube coral fan",
  "block.minecraft.dead_brain_coral_fan": "dead brain coral fan",
  "block.minecraft.dead_bubble_coral_fan": "dead bubble coral fan",
  "block.minecraft.dead_fire_coral_fan": "dead fire coral fan",
  "block.minecraft.dead_horn_coral_fan": "dead horn coral fan",
  "block.minecraft.blue_ice": "blue ice",
  "block.minecraft.conduit": "conduit",
  "block.minecraft.polished_granite_stairs": "polished granite stairs",
  "block.minecraft.smooth_red_sandstone_stairs": "smooth red sandstone stairs",
  "block.minecraft.mossy_stone_brick_stairs": "mossy stone brick stairs",
  "block.minecraft.polished_diorite_stairs": "polished diorite stairs",
  "block.minecraft.mossy_cobblestone_stairs": "mossy cobblestone stairs",
  "block.minecraft.end_stone_brick_stairs": "end stone brick stairs",
  "block.minecraft.stone_stairs": "stone stairs",
  "block.minecraft.smooth_sandstone_stairs": "smooth sandstone stairs",
  "block.minecraft.smooth_quartz_stairs": "smooth quartz stairs",
  "block.minecraft.granite_stairs": "granite stairs",
  "block.minecraft.andesite_stairs": "andesite stairs",
  "block.minecraft.red_nether_brick_stairs": "red nether brick stairs",
  "block.minecraft.polished_andesite_stairs": "polished andesite stairs",
  "block.minecraft.diorite_stairs": "diorite stairs",
  "block.minecraft.polished_granite_slab": "polished granite slab",
  "block.minecraft.smooth_red_sandstone_slab": "smooth red sandstone slab",
  "block.minecraft.mossy_stone_brick_slab": "mossy stone brick slab",
  "block.minecraft.polished_diorite_slab": "polished diorite slab",
  "block.minecraft.mossy_cobblestone_slab": "mossy cobblestone slab",
  "block.minecraft.end_stone_brick_slab": "end stone brick slab",
  "block.minecraft.smooth_sandstone_slab": "smooth sandstone slab",
  "block.minecraft.smooth_quartz_slab": "smooth quartz slab",
  "block.minecraft.granite_slab": "granite slab",
  "block.minecraft.andesite_slab": "andesite slab",
  "block.minecraft.red_nether_brick_slab": "red nether brick slab",
  "block.minecraft.polished_andesite_slab": "polished andesite slab",
  "block.minecraft.diorite_slab": "diorite slab",
  "block.minecraft.scaffolding": "scaffolding",
  "block.minecraft.iron_door": "iron door",
  "block.minecraft.oak_door": "oak door",
  "block.minecraft.spruce_door": "spruce door",
  "block.minecraft.birch_door": "birch door",
  "block.minecraft.jungle_door": "jungle door",
  "block.minecraft.acacia_door": "acacia door",
  "block.minecraft.dark_oak_door": "dark oak door",
  "block.minecraft.crimson_door": "crimson door",
  "block.minecraft.warped_door": "warped door",
  "block.minecraft.repeater": "redstone repeater",
  "block.minecraft.comparator": "redstone comparator",
  "block.minecraft.structure_block": "structure block",
  "block.minecraft.jigsaw": "jigsaw block",
  "item.minecraft.turtle_helmet": "turtle shell□□when on head:□+2 armour",
  "item.minecraft.scute": "scute",
  "item.minecraft.iron_shovel": "iron shovel□□when in main hand:□+3.5 attack damage□-3 attack speed",
  "item.minecraft.iron_pickaxe": "iron pickaxe□□when in main hand:□+3 attack damage□-2.8 attack speed",
  "item.minecraft.iron_axe": "iron axe□□when in main hand:□+8 attack damage□-3.1 attack speed",
  "item.minecraft.flint_and_steel": "flint and steel",
  "item.minecraft.apple": "apple",
  "item.minecraft.bow": "bow",
  "item.minecraft.arrow": "arrow",
  "item.minecraft.coal": "coal",
  "item.minecraft.charcoal": "charcoal",
  "item.minecraft.diamond": "diamond",
  "item.minecraft.iron_ingot": "iron ingot",
  "item.minecraft.gold_ingot": "gold ingot",
  "item.minecraft.netherite_ingot": "netherite ingot",
  "item.minecraft.netherite_scrap": "netherite scrap",
  "item.minecraft.iron_sword": "iron sword□□when in main hand:□+5 attack damage□-2.4 attack speed",
  "item.minecraft.wooden_sword": "wooden sword□□when in main hand:□+3 attack damage□-2.4 attack speed",
  "item.minecraft.wooden_shovel": "wooden shovel□□when in main hand:□+1.5 attack damage□-3 attack speed",
  "item.minecraft.wooden_pickaxe": "wooden pickaxe□□when in main hand:□+1 attack damage□-2.8 attack speed",
  "item.minecraft.wooden_axe": "wooden axe□□when in main hand:□+6 attack damage□-3.2 attack speed",
  "item.minecraft.stone_sword": "stone sword□□when in main hand:□+4 attack damage□-2.4 attack speed",
  "item.minecraft.stone_shovel": "stone shovel□□when in main hand:□+2.5 attack damage□-3 attack speed",
  "item.minecraft.stone_pickaxe": "stone pickaxe□□when in main hand:□+2 attack damage□-2.8 attack speed",
  "item.minecraft.stone_axe": "stone axe□□when in main hand:□+8 attack damage□-3.2 attack speed",
  "item.minecraft.diamond_sword": "diamond sword□□when in main hand:□+6 attack damage□-2.4 attack speed",
  "item.minecraft.diamond_shovel": "diamond shovel□□when in main hand:□+4.5 attack damage□-3 attack speed",
  "item.minecraft.diamond_pickaxe": "diamond pickaxe□□when in main hand:□+4 attack damage□-2.8 attack speed",
  "item.minecraft.diamond_axe": "diamond axe□□when in main hand:□+8 attack damage□-3 attack speed",
  "item.minecraft.stick": "stick",
  "item.minecraft.bowl": "bowl",
  "item.minecraft.mushroom_stew": "mushroom stew",
  "item.minecraft.golden_sword": "golden sword□□when in main hand:□+3 attack damage□-2.4 attack speed",
  "item.minecraft.golden_shovel": "golden shovel□□when in main hand:□+1.5 attack damage□-3 attack speed",
  "item.minecraft.golden_pickaxe": "golden pickaxe□□when in main hand:□+1 attack damage□-2.8 attack speed",
  "item.minecraft.golden_axe": "golden axe□□when in main hand:□+6 attack damage□-3 attack speed",
  "item.minecraft.netherite_sword": "netherite sword□□when in main hand:□+7 attack damage□-2.4 attack speed",
  "item.minecraft.netherite_shovel": "netherite shovel□□when in main hand:□+5.5 attack damage□-3 attack speed",
  "item.minecraft.netherite_pickaxe": "netherite pickaxe□□when in main hand:□+5 attack damage□-2.8 attack speed",
  "item.minecraft.netherite_axe": "netherite axe□□when in main hand:□+9 attack damage□-3 attack speed",
  "item.minecraft.string": "string",
  "item.minecraft.feather": "feather",
  "item.minecraft.gunpowder": "gunpowder",
  "item.minecraft.wooden_hoe": "wooden hoe□□when in main hand:□-3 attack speed",
  "item.minecraft.stone_hoe": "stone hoe□□when in main hand:□-2 attack speed",
  "item.minecraft.iron_hoe": "iron hoe□□when in main hand:□-1 attack speed",
  "item.minecraft.diamond_hoe": "diamond hoe□□when in main hand:",
  "item.minecraft.golden_hoe": "golden hoe□□when in main hand:□-3 attack speed",
  "item.minecraft.netherite_hoe": "netherite hoe□□when in main hand:",
  "item.minecraft.wheat_seeds": "wheat seeds",
  "item.minecraft.wheat": "wheat",
  "item.minecraft.bread": "bread",
  "item.minecraft.leather_helmet": "leather cap□□when on head:□+1 armour",
  "item.minecraft.leather_chestplate": "leather tunic□□when on body:□+3 armour",
  "item.minecraft.leather_leggings": "leather pants□□when on legs:□+2 armour",
  "item.minecraft.leather_boots": "leather boots□□when on feet:□+1 armour",
  "item.minecraft.chainmail_helmet": "chainmail helmet□□when on head:□+2 armour",
  "item.minecraft.chainmail_chestplate": "chainmail chestplate□□when on body:□+5 armour",
  "item.minecraft.chainmail_leggings": "chainmail leggings□□when on legs:□+4 armour",
  "item.minecraft.chainmail_boots": "chainmail boots□□when on feet:□+1 armour",
  "item.minecraft.iron_helmet": "iron helmet□□when on head:□+2 armour",
  "item.minecraft.iron_chestplate": "iron chestplate□□when on body:□+6 armour",
  "item.minecraft.iron_leggings": "iron leggings□□when on legs:□+5 armour",
  "item.minecraft.iron_boots": "iron boots□□when on feet:□+2 armour",
  "item.minecraft.diamond_helmet": "diamond helmet□□when on head:□+3 armour□+2 armour toughness",
  "item.minecraft.diamond_chestplate": "diamond chestplate□□when on body:□+8 armour□+2 armour toughness",
  "item.minecraft.diamond_leggings": "diamond leggings□□when on legs:□+6 armour□+2 armour toughness",
  "item.minecraft.diamond_boots": "diamond boots□□when on feet:□+3 armour□+2 armour toughness",
  "item.minecraft.golden_helmet": "golden helmet□□when on head:□+2 armour",
  "item.minecraft.golden_chestplate": "golden chestplate□□when on body:□+5 armour",
  "item.minecraft.golden_leggings": "golden leggings□□when on legs:□+3 armour",
  "item.minecraft.golden_boots": "golden boots□□when on feet:□+1 armour",
  "item.minecraft.netherite_helmet": "netherite helmet□□when on head:□+3 armour□+3 armour toughness□+1 knockback resistance",
  "item.minecraft.netherite_chestplate": "netherite chestplate□□when on body:□+8 armour□+3 armour toughness□+1 knockback resistance",
  "item.minecraft.netherite_leggings": "netherite leggings□□when on legs:□+6 armour□+3 armour toughness□+1 knockback resistance",
  "item.minecraft.netherite_boots": "netherite boots□□when on feet:□+3 armour□+3 armour toughness□+1 knockback resistance",
  "item.minecraft.flint": "flint",
  "item.minecraft.porkchop": "raw porkchop",
  "item.minecraft.cooked_porkchop": "cooked porkchop",
  "item.minecraft.painting": "painting",
  "item.minecraft.golden_apple": "golden apple",
  "item.minecraft.enchanted_golden_apple": "enchanted golden apple",
  "block.minecraft.oak_sign": "oak sign",
  "block.minecraft.spruce_sign": "spruce sign",
  "block.minecraft.birch_sign": "birch sign",
  "block.minecraft.jungle_sign": "jungle sign",
  "block.minecraft.acacia_sign": "acacia sign",
  "block.minecraft.dark_oak_sign": "dark oak sign",
  "block.minecraft.crimson_sign": "crimson sign",
  "block.minecraft.warped_sign": "warped sign",
  "item.minecraft.bucket": "bucket",
  "item.minecraft.water_bucket": "water bucket",
  "item.minecraft.lava_bucket": "lava bucket",
  "item.minecraft.minecart": "minecart",
  "item.minecraft.saddle": "saddle",
  "item.minecraft.redstone": "redstone dust",
  "item.minecraft.snowball": "snowball",
  "item.minecraft.oak_boat": "oak wood boat",
  "item.minecraft.leather": "leather",
  "item.minecraft.milk_bucket": "milk bucket",
  "item.minecraft.pufferfish_bucket": "bucket of pufferfish",
  "item.minecraft.salmon_bucket": "bucket of salmon",
  "item.minecraft.cod_bucket": "bucket of cod",
  "item.minecraft.tropical_fish_bucket": "bucket of tropical fish",
  "item.minecraft.brick": "brick",
  "item.minecraft.clay_ball": "clay ball",
  "block.minecraft.dried_kelp_block": "dried kelp block",
  "item.minecraft.paper": "paper",
  "item.minecraft.book": "book",
  "item.minecraft.slime_ball": "slimeball",
  "item.minecraft.chest_minecart": "minecart with chest",
  "item.minecraft.furnace_minecart": "minecart with furnace",
  "item.minecraft.egg": "egg",
  "item.minecraft.compass": "compass",
  "item.minecraft.fishing_rod": "fishing rod",
  "item.minecraft.clock": "clock",
  "item.minecraft.glowstone_dust": "glowstone dust",
  "item.minecraft.cod": "raw cod",
  "item.minecraft.salmon": "raw salmon",
  "item.minecraft.tropical_fish": "tropical fish",
  "item.minecraft.pufferfish": "pufferfish",
  "item.minecraft.cooked_cod": "cooked cod",
  "item.minecraft.cooked_salmon": "cooked salmon",
  "item.minecraft.ink_sac": "ink sac",
  "item.minecraft.red_dye": "red dye",
  "item.minecraft.green_dye": "green dye",
  "item.minecraft.cocoa_beans": "cocoa beans",
  "item.minecraft.lapis_lazuli": "lapis lazuli",
  "item.minecraft.purple_dye": "purple dye",
  "item.minecraft.cyan_dye": "cyan dye",
  "item.minecraft.light_gray_dye": "light grey dye",
  "item.minecraft.gray_dye": "grey dye",
  "item.minecraft.pink_dye": "pink dye",
  "item.minecraft.lime_dye": "lime dye",
  "item.minecraft.yellow_dye": "yellow dye",
  "item.minecraft.light_blue_dye": "light blue dye",
  "item.minecraft.magenta_dye": "magenta dye",
  "item.minecraft.orange_dye": "orange dye",
  "item.minecraft.bone_meal": "bone meal",
  "item.minecraft.blue_dye": "blue dye",
  "item.minecraft.brown_dye": "brown dye",
  "item.minecraft.black_dye": "black dye",
  "item.minecraft.white_dye": "white dye",
  "item.minecraft.bone": "bone",
  "item.minecraft.sugar": "sugar",
  "block.minecraft.cake": "cake",
  "block.minecraft.white_bed": "white bed",
  "block.minecraft.orange_bed": "orange bed",
  "block.minecraft.magenta_bed": "magenta bed",
  "block.minecraft.light_blue_bed": "light blue bed",
  "block.minecraft.yellow_bed": "yellow bed",
  "block.minecraft.lime_bed": "lime bed",
  "block.minecraft.pink_bed": "pink bed",
  "block.minecraft.gray_bed": "grey bed",
  "block.minecraft.light_gray_bed": "light grey bed",
  "block.minecraft.cyan_bed": "cyan bed",
  "block.minecraft.purple_bed": "purple bed",
  "block.minecraft.blue_bed": "blue bed",
  "block.minecraft.brown_bed": "brown bed",
  "block.minecraft.green_bed": "green bed",
  "block.minecraft.red_bed": "red bed",
  "block.minecraft.black_bed": "black bed",
  "item.minecraft.cookie": "biscuit",
  "item.minecraft.filled_map": "map□#0",
  "item.minecraft.shears": "shears",
  "item.minecraft.melon_slice": "melon slice",
  "item.minecraft.dried_kelp": "dried kelp",
  "item.minecraft.pumpkin_seeds": "pumpkin seeds",
  "item.minecraft.melon_seeds": "watermelon seeds",
  "item.minecraft.beef": "raw beef",
  "item.minecraft.cooked_beef": "steak",
  "item.minecraft.chicken": "raw chicken",
  "item.minecraft.cooked_chicken": "roast chicken",
  "item.minecraft.rotten_flesh": "rotten flesh",
  "item.minecraft.ender_pearl": "ender pearl",
  "item.minecraft.blaze_rod": "blaze rod",
  "item.minecraft.ghast_tear": "ghast tear",
  "item.minecraft.gold_nugget": "gold nugget",
  "item.minecraft.nether_wart": "nether wart",
  "item.minecraft.potion": "uncraftable potion□no effects",
  "item.minecraft.glass_bottle": "glass bottle",
  "item.minecraft.spider_eye": "spider eye",
  "item.minecraft.fermented_spider_eye": "fermented spider eye",
  "item.minecraft.blaze_powder": "blaze powder",
  "item.minecraft.magma_cream": "magma cream",
  "block.minecraft.brewing_stand": "brewing stand",
  "block.minecraft.cauldron": "cauldron",
  "item.minecraft.ender_eye": "eye of ender",
  "item.minecraft.glistering_melon_slice": "glistering melon slice",
  "item.minecraft.bat_spawn_egg": "bat spawn egg",
  "item.minecraft.bee_spawn_egg": "bee spawn egg",
  "item.minecraft.blaze_spawn_egg": "blaze spawn egg",
  "item.minecraft.cat_spawn_egg": "cat spawn egg",
  "item.minecraft.cave_spider_spawn_egg": "cave spider spawn egg",
  "item.minecraft.chicken_spawn_egg": "chicken spawn egg",
  "item.minecraft.cod_spawn_egg": "cod spawn egg",
  "item.minecraft.cow_spawn_egg": "cow spawn egg",
  "item.minecraft.creeper_spawn_egg": "creeper spawn egg",
  "item.minecraft.dolphin_spawn_egg": "dolphin spawn egg",
  "item.minecraft.donkey_spawn_egg": "donkey spawn egg",
  "item.minecraft.drowned_spawn_egg": "drowned spawn egg",
  "item.minecraft.elder_guardian_spawn_egg": "elder guardian spawn egg",
  "item.minecraft.enderman_spawn_egg": "enderman spawn egg",
  "item.minecraft.endermite_spawn_egg": "endermite spawn egg",
  "item.minecraft.evoker_spawn_egg": "evoker spawn egg",
  "item.minecraft.fox_spawn_egg": "fox spawn egg",
  "item.minecraft.ghast_spawn_egg": "ghast spawn egg",
  "item.minecraft.guardian_spawn_egg": "guardian spawn egg",
  "item.minecraft.hoglin_spawn_egg": "hoglin spawn egg",
  "item.minecraft.horse_spawn_egg": "horse spawn egg",
  "item.minecraft.husk_spawn_egg": "husk spawn egg",
  "item.minecraft.llama_spawn_egg": "llama spawn egg",
  "item.minecraft.magma_cube_spawn_egg": "magma cube spawn egg",
  "item.minecraft.mooshroom_spawn_egg": "mooshroom spawn egg",
  "item.minecraft.mule_spawn_egg": "mule spawn egg",
  "item.minecraft.ocelot_spawn_egg": "ocelot spawn egg",
  "item.minecraft.panda_spawn_egg": "panda spawn egg",
  "item.minecraft.parrot_spawn_egg": "parrot spawn egg",
  "item.minecraft.phantom_spawn_egg": "phantom spawn egg",
  "item.minecraft.pig_spawn_egg": "pig spawn egg",
  "item.minecraft.piglin_spawn_egg": "piglin spawn egg",
  "item.minecraft.pillager_spawn_egg": "pillager spawn egg",
  "item.minecraft.polar_bear_spawn_egg": "polar bear spawn egg",
  "item.minecraft.pufferfish_spawn_egg": "pufferfish spawn egg",
  "item.minecraft.rabbit_spawn_egg": "rabbit spawn egg",
  "item.minecraft.ravager_spawn_egg": "ravager spawn egg",
  "item.minecraft.salmon_spawn_egg": "salmon spawn egg",
  "item.minecraft.sheep_spawn_egg": "sheep spawn egg",
  "item.minecraft.shulker_spawn_egg": "shulker spawn egg",
  "item.minecraft.silverfish_spawn_egg": "silverfish spawn egg",
  "item.minecraft.skeleton_spawn_egg": "skeleton spawn egg",
  "item.minecraft.skeleton_horse_spawn_egg": "skeleton horse spawn egg",
  "item.minecraft.slime_spawn_egg": "slime spawn egg",
  "item.minecraft.spider_spawn_egg": "spider spawn egg",
  "item.minecraft.squid_spawn_egg": "squid spawn egg",
  "item.minecraft.stray_spawn_egg": "stray spawn egg",
  "item.minecraft.strider_spawn_egg": "strider spawn egg",
  "item.minecraft.trader_llama_spawn_egg": "trader llama spawn egg",
  "item.minecraft.tropical_fish_spawn_egg": "tropical fish spawn egg",
  "item.minecraft.turtle_spawn_egg": "turtle spawn egg",
  "item.minecraft.vex_spawn_egg": "vex spawn egg",
  "item.minecraft.villager_spawn_egg": "villager spawn egg",
  "item.minecraft.vindicator_spawn_egg": "vindicator spawn egg",
  "item.minecraft.wandering_trader_spawn_egg": "wandering trader spawn egg",
  "item.minecraft.witch_spawn_egg": "witch spawn egg",
  "item.minecraft.wither_skeleton_spawn_egg": "wither skeleton spawn egg",
  "item.minecraft.wolf_spawn_egg": "wolf spawn egg",
  "item.minecraft.zoglin_spawn_egg": "zoglin spawn egg",
  "item.minecraft.zombie_spawn_egg": "zombie spawn egg",
  "item.minecraft.zombie_horse_spawn_egg": "zombie horse spawn egg",
  "item.minecraft.zombie_villager_spawn_egg": "zombie villager spawn egg",
  "item.minecraft.zombified_piglin_spawn_egg": "zombified piglin spawn egg",
  "item.minecraft.experience_bottle": "bottle o' enchanting",
  "item.minecraft.fire_charge": "fire charge",
  "item.minecraft.writable_book": "book and quill",
  "item.minecraft.written_book": "written book",
  "item.minecraft.emerald": "emerald",
  "item.minecraft.item_frame": "item frame",
  "block.minecraft.flower_pot": "flower pot",
  "item.minecraft.carrot": "carrot",
  "item.minecraft.potato": "potato",
  "item.minecraft.baked_potato": "baked potato",
  "item.minecraft.poisonous_potato": "poisonous potato",
  "item.minecraft.map": "empty map",
  "item.minecraft.golden_carrot": "golden carrot",
  "block.minecraft.skeleton_skull": "skeleton skull",
  "block.minecraft.wither_skeleton_skull": "wither skeleton skull",
  "block.minecraft.player_head": "player head",
  "block.minecraft.zombie_head": "zombie head",
  "block.minecraft.creeper_head": "creeper head",
  "block.minecraft.dragon_head": "ender dragon head",
  "item.minecraft.carrot_on_a_stick": "carrot on a stick",
  "item.minecraft.warped_fungus_on_a_stick": "warped fungus on a stick",
  "item.minecraft.nether_star": "nether star",
  "item.minecraft.pumpkin_pie": "pumpkin pie",
  "item.minecraft.firework_rocket": "firework rocket",
  "item.minecraft.firework_star": "firework star",
  "item.minecraft.enchanted_book": "enchanted book",
  "item.minecraft.nether_brick": "nether brick",
  "item.minecraft.quartz": "nether quartz",
  "item.minecraft.tnt_minecart": "minecart with tnt",
  "item.minecraft.hopper_minecart": "minecart with hopper",
  "item.minecraft.prismarine_shard": "prismarine shard",
  "item.minecraft.prismarine_crystals": "prismarine crystals",
  "item.minecraft.rabbit": "raw rabbit",
  "item.minecraft.cooked_rabbit": "cooked rabbit",
  "item.minecraft.rabbit_stew": "rabbit stew",
  "item.minecraft.rabbit_foot": "rabbit's foot",
  "item.minecraft.rabbit_hide": "rabbit hide",
  "item.minecraft.armor_stand": "armour stand",
  "item.minecraft.iron_horse_armor": "iron horse armour",
  "item.minecraft.golden_horse_armor": "golden horse armour",
  "item.minecraft.diamond_horse_armor": "diamond horse armour",
  "item.minecraft.leather_horse_armor": "leather horse armour",
  "item.minecraft.lead": "lead",
  "item.minecraft.name_tag": "name tag",
  "item.minecraft.command_block_minecart": "minecart with command block",
  "item.minecraft.mutton": "raw lambchops",
  "item.minecraft.cooked_mutton": "roast lambchops",
  "block.minecraft.white_banner": "white banner",
  "block.minecraft.orange_banner": "orange banner",
  "block.minecraft.magenta_banner": "magenta banner",
  "block.minecraft.light_blue_banner": "light blue banner",
  "block.minecraft.yellow_banner": "yellow banner",
  "block.minecraft.lime_banner": "lime banner",
  "block.minecraft.pink_banner": "pink banner",
  "block.minecraft.gray_banner": "grey banner",
  "block.minecraft.light_gray_banner": "light grey banner",
  "block.minecraft.cyan_banner": "cyan banner",
  "block.minecraft.purple_banner": "purple banner",
  "block.minecraft.blue_banner": "blue banner",
  "block.minecraft.brown_banner": "brown banner",
  "block.minecraft.green_banner": "green banner",
  "block.minecraft.red_banner": "red banner",
  "block.minecraft.black_banner": "black banner",
  "item.minecraft.end_crystal": "end crystal",
  "item.minecraft.chorus_fruit": "chorus fruit",
  "item.minecraft.popped_chorus_fruit": "popped chorus fruit",
  "item.minecraft.beetroot": "beetroot",
  "item.minecraft.beetroot_seeds": "beetroot seeds",
  "item.minecraft.beetroot_soup": "beetroot soup",
  "item.minecraft.dragon_breath": "dragon's breath",
  "item.minecraft.splash_potion": "uncraftable splash potion□no effects",
  "item.minecraft.spectral_arrow": "spectral arrow",
  "item.minecraft.tipped_arrow": "uncraftable tipped arrow□no effects",
  "item.minecraft.lingering_potion": "lingering uncraftable potion□no effects",
  "item.minecraft.shield": "shield",
  "item.minecraft.elytra": "elytra",
  "item.minecraft.spruce_boat": "spruce wood boat",
  "item.minecraft.birch_boat": "birch wood boat",
  "item.minecraft.jungle_boat": "jungle wood boat",
  "item.minecraft.acacia_boat": "acacia wood boat",
  "item.minecraft.dark_oak_boat": "dark oak wood boat",
  "item.minecraft.totem_of_undying": "totem of undying",
  "item.minecraft.shulker_shell": "shulker shell",
  "item.minecraft.iron_nugget": "iron nugget",
  "item.minecraft.knowledge_book": "knowledge book",
  "item.minecraft.debug_stick": "debug stick",
  "item.minecraft.music_disc_13": "music disc□c418 - 13",
  "item.minecraft.music_disc_cat": "music disc□c418 - cat",
  "item.minecraft.music_disc_blocks": "music disc□c418 - blocks",
  "item.minecraft.music_disc_chirp": "music disc□c418 - chirp",
  "item.minecraft.music_disc_far": "music disc□c418 - far",
  "item.minecraft.music_disc_mall": "music disc□c418 - mall",
  "item.minecraft.music_disc_mellohi": "music disc□c418 - mellohi",
  "item.minecraft.music_disc_stal": "music disc□c418 - stal",
  "item.minecraft.music_disc_strad": "music disc□c418 - strad",
  "item.minecraft.music_disc_ward": "music disc□c418 - ward",
  "item.minecraft.music_disc_11": "music disc□c418 - 11",
  "item.minecraft.music_disc_wait": "music disc□c418 - wait",
  "item.minecraft.music_disc_pigstep": "music disc□lena raine - pigstep",
  "item.minecraft.trident": "trident□□when in main hand:□+8 attack damage□-2.9 attack speed",
  "item.minecraft.phantom_membrane": "phantom membrane",
  "item.minecraft.nautilus_shell": "nautilus shell",
  "item.minecraft.heart_of_the_sea": "heart of the sea",
  "item.minecraft.crossbow": "crossbow",
  "item.minecraft.suspicious_stew": "suspicious stew",
  "block.minecraft.loom": "loom",
  "item.minecraft.flower_banner_pattern": "banner pattern□flower charge",
  "item.minecraft.creeper_banner_pattern": "banner pattern□creeper charge",
  "item.minecraft.skull_banner_pattern": "banner pattern□skull charge",
  "item.minecraft.mojang_banner_pattern": "banner pattern□thing",
  "item.minecraft.globe_banner_pattern": "banner pattern□globe",
  "item.minecraft.piglin_banner_pattern": "banner pattern□snout",
  "block.minecraft.composter": "composter",
  "block.minecraft.barrel": "barrel",
  "block.minecraft.smoker": "smoker",
  "block.minecraft.blast_furnace": "blast furnace",
  "block.minecraft.cartography_table": "cartography table",
  "block.minecraft.fletching_table": "fletching table",
  "block.minecraft.grindstone": "grindstone",
  "block.minecraft.lectern": "lectern",
  "block.minecraft.smithing_table": "smithing table",
  "block.minecraft.stonecutter": "stonecutter",
  "block.minecraft.bell": "bell",
  "block.minecraft.lantern": "lantern",
  "block.minecraft.soul_lantern": "soul lantern",
  "item.minecraft.sweet_berries": "sweet berries",
  "block.minecraft.campfire": "campfire",
  "block.minecraft.soul_campfire": "soul campfire",
  "block.minecraft.shroomlight": "shroomlight",
  "item.minecraft.honeycomb": "honeycomb",
  "block.minecraft.bee_nest": "bee nest",
  "block.minecraft.beehive": "beehive",
  "item.minecraft.honey_bottle": "honey bottle",
  "block.minecraft.honey_block": "honey block",
  "block.minecraft.honeycomb_block": "honeycomb block",
  "block.minecraft.lodestone": "lodestone",
  "block.minecraft.netherite_block": "block of netherite",
  "block.minecraft.ancient_debris": "ancient debris",
  "block.minecraft.target": "target",
  "block.minecraft.crying_obsidian": "crying obsidian",
  "block.minecraft.blackstone": "blackstone",
  "block.minecraft.blackstone_slab": "blackstone slab",
  "block.minecraft.blackstone_stairs": "blackstone stairs",
  "block.minecraft.gilded_blackstone": "gilded blackstone",
  "block.minecraft.polished_blackstone": "polished blackstone",
  "block.minecraft.polished_blackstone_slab": "polished blackstone slab",
  "block.minecraft.polished_blackstone_stairs": "polished blackstone stairs",
  "block.minecraft.chiseled_polished_blackstone": "chiselled polished blackstone",
  "block.minecraft.polished_blackstone_bricks": "polished blackstone bricks",
  "block.minecraft.polished_blackstone_brick_slab": "polished blackstone brick slab",
  "block.minecraft.polished_blackstone_brick_stairs": "polished blackstone brick stairs",
  "block.minecraft.cracked_polished_blackstone_bricks": "cracked polished blackstone bricks",
  "block.minecraft.respawn_anchor": "respawn anchor",
}
export const en_nz = items; 
